import {
  CHINA_TOOLBOX_URL,
  COUNTRY_CODE_ALIASES,
  DEFAULT_TOOLBOX_URL,
  LANGUAGE_DEFAULTS,
  TECALOR_TOOLBOX_URL,
  TOOLBOX_URLS,
} from '@common/components/PageHeader/toolboxUrls';

interface ResolveToolboxUrlParams {
  /** User culture string, e.g. "en-US"; only the part before "-" is used. */
  language?: string;
  /** ISO alpha-2 country code, e.g. "DE", "GB". */
  countryCode?: string;
  isTecalor: boolean;
  isChinaDeployment: boolean;
}

const CHINA_API_HOST_FRAGMENT = 'stiebel-eltron.cn';

/**
 * REST_API_HOST is substituted into the bundle at deploy time
 * (support/injectGlobalVariables.ps1) — same mechanism as OPPOSITE_APP_URL.
 */
export function isChinaDeployment(): boolean {
  return !!process.env.REST_API_HOST?.includes(CHINA_API_HOST_FRAGMENT);
}

export function resolveToolboxUrl({
  language,
  countryCode,
  isTecalor,
  isChinaDeployment: chinaDeployment,
}: ResolveToolboxUrlParams): string {
  if (chinaDeployment) {
    return CHINA_TOOLBOX_URL;
  }
  if (isTecalor) {
    return TECALOR_TOOLBOX_URL;
  }

  const lang = language?.split('-')[0]?.toLowerCase() ?? '';
  const isoCountry = countryCode?.toUpperCase() ?? '';
  const location = COUNTRY_CODE_ALIASES.get(isoCountry) ?? isoCountry;

  const exactMatch = TOOLBOX_URLS.get(`${lang}_${location}`);
  if (exactMatch) {
    return exactMatch;
  }

  const languageDefaultKey = LANGUAGE_DEFAULTS.get(lang);
  if (languageDefaultKey) {
    return TOOLBOX_URLS.get(languageDefaultKey) ?? DEFAULT_TOOLBOX_URL;
  }

  return DEFAULT_TOOLBOX_URL;
}
